<script setup lang="ts">
import { computed } from 'vue';
import type { CardProps, NormalizedCardProps } from './card.types';
import { useSharedState } from 'composables/useSharedState';
import { cardClasses } from './card.styles';

const props = withDefaults(defineProps<CardProps>(), {
  as: 'article',
  color: 'neutral',
  variant: 'subtle',
  size: 'md'
});

const normalizedProps = computed<NormalizedCardProps>(() => {
  const { color, variant, size } = props;

  if (color === 'mono' && variant !== 'solid') {
    console.warn(
      `[e-card] Invalid prop combination: color="mono" can only be used with variant="solid". Current variant: "${variant}". Forcing variant="solid".`
    );
    return {
      color,
      variant: 'solid',
      size
    };
  }

  return { color, variant, size };
});

useSharedState(normalizedProps.value);
</script>

<template>
  <component
    :is="as"
    class="e-card"
    :class="cardClasses(normalizedProps)"
  >
    <slot />
  </component>
</template>
